<div class="unauthorized-container">
    <div class="error-content">
        <h1>403</h1>
        <h2>Access Denied</h2>
        <p>You are not authorized to access this application.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
    </div>
</div>
